import React, { useEffect, useState } from "react";

import {
    Row,
    Col,
    Button,
    Alert
} from "reactstrap";

import { AutoComplete } from "primereact/autocomplete";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { useDispatch } from "react-redux";

import "./LineasNegocio.css";

import {
    listarLineasNegocio,
    listarRamos,
    eliminarRamoCompromiso
} from "../../../redux/aCompromisos";


const LineaNegocioSection = ({
    lineasSeleccionadas,
    onChange,
    onRamoSeleccionado,
    idCompromiso,
    errorExterno
}) => {

    const dispatch = useDispatch();

    const [lineaSeleccionada, setLineaSeleccionada] = useState(null);
    const [ramoSeleccionado, setRamoSeleccionado] = useState(null);

    const [lineasCatalogo, setLineasCatalogo] = useState([]);
    const [ramosCatalogo, setRamosCatalogo] = useState([]);

    const [lineasFiltradas, setlineasFiltradas] = useState([]);
    const [ramosFiltrados, setRamosFiltrados] = useState([]);

    const [cargandoRamos, setCargandoRamos] =
        useState(false);

    const [error, setError] =
        useState("");


    useEffect(() => {

        const cargarLineas = async () => {

            try {

                const respuesta =
                    await dispatch(
                        listarLineasNegocio()
                    );

                if (
                    respuesta &&
                    respuesta.success !== false
                ) {


                    setLineasCatalogo(
                        respuesta.data || respuesta
                    );
                }

            } catch (e) {

                setError(
                    "No fue posible cargar las líneas de negocio"
                );
            }
        };

        cargarLineas();

    }, [dispatch]);

    const buscarLineas = (event) => {

        const termino =
            event.query
                ? event.query
                    .trim()
                    .toLowerCase()
                : "";

        const resultados =
            lineasCatalogo.filter((item) => {

                const nombre =
                    item.lnDescripcion
                        ? item.lnDescripcion.toLowerCase()
                        : "";

                return nombre.includes(termino);
            });

        setlineasFiltradas(resultados);
    };

    const buscarRamos = (event) => {

        const termino = event.query
            ? event.query.trim().toLowerCase()
            : "";

        const resultados = ramosCatalogo.filter((item) => {

            const nombre = item.rmDescripcion
                ? item.rmDescripcion.toLowerCase()
                : "";

            return nombre.includes(termino);
        });

        setRamosFiltrados(resultados);
    };


    const handleLineaChange = async (event) => {

        const linea = event.value;

        setLineaSeleccionada(linea);
        setRamoSeleccionado(null);
        if (onRamoSeleccionado) {
            onRamoSeleccionado(null);
        }
        setRamosCatalogo([]);
        setRamosFiltrados([]);
        setError("");

        if (!linea) {
            return;
        }

        if (!linea.lnCodigo) {
            return;
        }


        try {

            setCargandoRamos(true);

            const respuesta =
                await dispatch(
                    listarRamos(linea.lnCodigo)
                );

            if (
                respuesta &&
                respuesta.success !== false
            ) {

                setRamosCatalogo(
                    respuesta.data || respuesta
                );
            }

        } catch (e) {

            setError(
                "No fue posible cargar los ramos"
            );

        } finally {

            setCargandoRamos(false);
        }
    };


    const handleAgregar = () => {

        setError("");

        if (
            !lineaSeleccionada ||
            !lineaSeleccionada.lnCodigo
        ) {
            setError(
                "Seleccione una línea de negocio válida"
            );
            return;
        }

        if (!ramoSeleccionado ||
            !ramoSeleccionado.rmCodigo) {
            setError(
                "Seleccione un ramo válido"
            );
            return;
        }

        /*
         * Evitar repetir exactamente
         * línea + ramo.
         */
        const yaExiste =
            lineasSeleccionadas.some(
                (item) =>
                    Number(item.lnCodigo) ===
                    Number(
                        lineaSeleccionada.lnCodigo
                    ) &&
                    Number(item.rmCodigo) ===
                    Number(
                        ramoSeleccionado.rmCodigo
                    )
            );

        if (yaExiste) {

            setError(
                "La línea de negocio y el ramo ya fueron agregados"
            );

            return;
        }


        const nuevaLinea = {

            lnCodigo:
                Number(
                    lineaSeleccionada.lnCodigo
                ),

            lnDescripcion:
                lineaSeleccionada.lnDescripcion,

            rmCodigo:
                Number(
                    ramoSeleccionado.rmCodigo
                ),

            rmDescripcion:
                ramoSeleccionado.rmDescripcion,

            /*
             * Inicialmente es local.
             *
             * Si cargas registros ya existentes
             * desde Mongo deberían venir con
             * persistido: true.
             */
            persistido: false
        };


        onChange([
            ...lineasSeleccionadas,
            nuevaLinea
        ]);


        setLineaSeleccionada(null);
        setRamoSeleccionado(null);
        setRamosCatalogo([]);
        setRamosFiltrados([]);
    };



    const handleEliminar = async (rowData) => {

        setError("");

        try {


            if (
                idCompromiso &&
                rowData.persistido
            ) {

                const respuesta =
                    await dispatch(
                        eliminarRamoCompromiso(
                            idCompromiso,
                            rowData.lnCodigo,
                            rowData.rmCodigo
                        )
                    );

                if (
                    !respuesta ||
                    respuesta.success === false
                ) {
                    return;
                }
            }



            const nuevasLineas =
                lineasSeleccionadas.filter(
                    (item) =>
                        !(
                            Number(item.lnCodigo) ===
                            Number(
                                rowData.lnCodigo
                            ) &&
                            Number(item.rmCodigo) ===
                            Number(
                                rowData.rmCodigo
                            )
                        )
                );

            onChange(nuevasLineas);

        } catch (e) {

            setError(
                "No fue posible eliminar el ramo"
            );
        }
    };


    const eliminarBody = (rowData) => {

        return (
            <button
                type="button"
                className="btn-eliminar-linea"
                onClick={() => handleEliminar(rowData)}
            >
                Eliminar
            </button>
        );
    };


    return (
        <>

            <h3 className="compromiso-section-subtitle">
                Líneas de negocio
            </h3>


            <div className="linea-negocio-box">
                {(error || errorExterno) && (
                    <Alert color="danger" className="mb-3">
                        {error || errorExterno}
                    </Alert>
                )}


                <Row className="align-items-end">

                    <Col md="4">

                        <div className="form-group">

                            <label className="linea-negocio-label">
                                Líneas de negocio
                            </label>

                            <AutoComplete
                                value={lineaSeleccionada}
                                suggestions={lineasFiltradas}
                                completeMethod={buscarLineas}
                                onChange={handleLineaChange}
                                field="lnDescripcion"
                                placeholder="Seleccione"
                                dropdown
                                className="w-100"
                            />

                        </div>

                    </Col>


                    <Col md="4">

                        <div className="form-group">

                            <label className="linea-negocio-label">
                                Ramo
                            </label>

                            <AutoComplete
                                value={ramoSeleccionado}
                                suggestions={ramosFiltrados}
                                completeMethod={buscarRamos}
                                onChange={(event) => {
                                    const ramo = event.value;

                                    setRamoSeleccionado(ramo);

                                    if (onRamoSeleccionado) {
                                        onRamoSeleccionado(
                                            ramo && ramo.rmCodigo
                                                ? ramo
                                                : null
                                        );
                                    }
                                }}
                                field="rmDescripcion"
                                placeholder="Seleccione"
                                dropdown
                                disabled={
                                    !lineaSeleccionada ||
                                    cargandoRamos
                                }
                                className="w-100"
                            />

                        </div>

                    </Col>


                    <Col md="4">
                        <div className="form-group">
                            <label style={{ visibility: "hidden" }}>
                                Acciones
                            </label>
                            <Button
                                className="btn-agregar-linea"
                                onClick={handleAgregar}
                            >
                                + Agregar línea de negocio
                            </Button>
                        </div>
                    </Col>

                </Row>

            </div>




            <div className="linea-negocio-tabla-wrapper">

                <DataTable
                    value={lineasSeleccionadas}
                    className="linea-negocio-tabla"
                    responsiveLayout="scroll"
                >

                    <Column
                        field="lnDescripcion"
                        header="LÍNEAS DE NEGOCIO"
                    />

                    <Column
                        field="rmDescripcion"
                        header="RAMO"
                    />

                    <Column
                        body={eliminarBody}
                        header=""
                        style={{ width: "160px", textAlign: "center" }}
                        headerStyle={{ width: "160px" }}
                    />

                </DataTable>

            </div>


        </>
    );
};

export default LineaNegocioSection;